export const LOGIN_DELIVERY_USER = "LOGIN_DELIVERY_USER";
export const LOGOUT_DELIVERY_USER = "LOGOUT_DELIVERY_USER";
export const UPDATE_DELIVERY_USER_INFO = "UPDATE_DELIVERY_USER_INFO";
export const UPDATE_DELIVERY_ORDER_HISTORY = "UPDATE_DELIVERY_ORDER_HISTORY";
